import Dexie, { Table } from 'dexie';
import { Injectable } from '@angular/core';

export interface AppSetting {
	key: string;
	value: any;
}

@Injectable({
	providedIn: 'root',
})
export class AppDB extends Dexie {
	appSettings!: Table<AppSetting, string>;

	constructor() {
		super('ito-hub');
		this.version(1).stores({
			appSettings: 'key, value',
		});
		this.on('populate', () => this.populate());
	}

	async populate() {
		db.appSettings.add({
			key: 'mobileMenu',
			value: ['MAINMENU.TEAMCALENDAR', 'MAINMENU.PROJECTS', 'MAINMENU.R18.LUNCHBOX', 'MAINMENU.EVENTS'],
		});
	}
}
export const db = new AppDB();
